const styles = theme => ({
  root: {
    backgroundColor: theme.palette.primary.light,
    padding: `0 ${theme.spacing.unit * 2}px`,
    marginBottom: theme.spacing.unit,
    '&:last-child': {
      marginBottom: 0
    },
    borderRadius: '2px'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    height: 56,
    cursor: 'pointer'
  },
  name: {
    color: theme.palette.primary.main,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    margin: 0,
    marginRight: theme.spacing.unit * 2,
    textTransform: 'uppercase'
  },
  productIds: {
    flex: 1,
    color: theme.palette.primary.main,
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '400',
    letterSpacing: '0.1px',
    lineHeight: '16px',
    margin: 0,
    textTransform: 'uppercase'
  },
  pallet: {
    color: theme.palette.primary.main,
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    fontWeight: '400',
    marginRight: theme.spacing.unit * 2
  },
  expandButton: {
    color: theme.palette.primary.main,
    margin: 0,
    padding: 0,
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  body: {
    borderTop: '1px solid rgba(0,0,0,0.12)',
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit}px`
  },
  products: {
    paddingBottom: theme.spacing.unit * 3,
    borderBottom: '1px dashed rgba(0,0,0,0.12)',
    display: 'flex',
    flexWrap: 'wrap'
  },
  units: {
    marginTop: theme.spacing.unit * 3,
    display: 'flex',
    flexWrap: 'wrap'
  }
});

export default styles;
